import { render, staticRenderFns } from "./all_by_cate_goods_list.mpx?vue&type=template&id=3872891b&scoped=true&component=true&componentId=all_by_cate_goods_list4bb590cf"
import script from "./all_by_cate_goods_list.mpx?vue&type=script&lang=js&component=true&componentId=all_by_cate_goods_list4bb590cf"
export * from "./all_by_cate_goods_list.mpx?vue&type=script&lang=js&component=true&componentId=all_by_cate_goods_list4bb590cf"
import style0 from "./all_by_cate_goods_list.mpx?vue&type=style&index=0&id=3872891b&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m4bb590cf%22%7D&component=true&componentId=all_by_cate_goods_list4bb590cf"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872891b",
  null
  
)

export default component.exports